// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectChipsInput-module__root__3-OpQ","wrapper":"SelectChipsInput-module__wrapper__1s9mq","input-field":"SelectChipsInput-module__input-field__15ujv"};